import { render, staticRenderFns } from "./work-order-layout.vue?vue&type=template&id=81314bfa"
import script from "./work-order-layout.vue?vue&type=script&lang=js"
export * from "./work-order-layout.vue?vue&type=script&lang=js"
import style0 from "./work-order-layout.vue?vue&type=style&index=0&id=81314bfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports